import { render } from "./OrderCheckout.vue?vue&type=template&id=8af5612c&scoped=true"
import script from "./OrderCheckout.vue?vue&type=script&lang=js"
export * from "./OrderCheckout.vue?vue&type=script&lang=js"

import "./OrderCheckout.vue?vue&type=style&index=0&id=8af5612c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8af5612c"]])

export default __exports__